import { getService, getServiceAsync } from 'data/function';
import { applicationListStateName } from 'modules/application/list';
export class DeleteApplicationProcessor {
    static get $state() {
        return getService('$state');
    }
    static async process({ message, trackingProperties, source }) {
        try {
            const applicationService = await getServiceAsync('ApplicationService2');
            const messageResponse = {
                response: await applicationService.deleteAndRevokeApplication(message.content.application),
                trackingProperties,
            };
            source.postMessage(messageResponse, '*');
            DeleteApplicationProcessor.$state.go(applicationListStateName);
        }
        catch (e) {
            const errorResponse = {
                error: e.toString(),
                trackingProperties,
            };
            source.postMessage(errorResponse, '*');
            const loadingService = await getServiceAsync('LoadingService');
            loadingService.stopLoading();
        }
    }
}
